import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Footer from './footer';
import NavigationBar from './navigation-bar';
import AppleTVPlusThemedRow from './AppleTVPlusThemedRow';
import SVODSideMenu from './SVODSideMenu';

import ThumbnailItem from './thumbnail-item';
import VideoPlayer from './video-player';
import { updateWatchlist, toggleVolume, setSelectedAsset, setSelectedAssetRow } from '../../redux/actions/SVOD';
import PauseImg from '../../assets/svod/appletv-icons/pause.svg';
import MutedImg from '../../assets/svod/appletv-icons/muted.svg';
import UnmutedImg from '../../assets/svod/appletv-icons/unmuted.svg';
import PlayImg from '../../assets/svod/player-controls/play.svg';
import thin_left_chevron from '../../assets/svod/buttons/thin-left-chevron.png';
import thin_right_chevron from '../../assets/svod/buttons/thin-right-chevron.png';
import popcornImg from '../../assets/svod/popcorn-score.png';
import rottenTomotoesImg from '../../assets/svod/rotten-tomatoes-fresh.png';
import dolby_atmos from "../../assets/svod/appletv-icons/dolby-atmos.svg";
import dolby_vision from "../../assets/svod/appletv-icons/dolby-vision.svg";
import SVODStatus from '../../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../../analytics/analytics-events/constants';
import { EnvType, SVOD_ASSET_NAVIGATION, FORCED_ENTRY, MANUAL_NAVIGATION } from "./constants";
import { convertToMinutes } from '../../functions/helpers';
import { returnTimeInSVOD, returnSelectedRowFromAsset, returnTargetAssetInfo, returnBrandingInformation } from '../../functions/utils';
import { returnSVODAssetMetadata } from "../../functions/helpers";
import svodMessages from '../../locales/svod';

const COUNTDOWN_TO_VIDEO_PLAY = 10000; // ms
const VIDEO_PLAY_LIMIT = 90000; // ms
const SHOW_PAGE_THUMBNAIL_CLASS = 'show-page-thumbnail';

class ShowPage extends React.Component {
	constructor(props) {
		super(props);
		this.videosListEnd = React.createRef();

		this.state = {
			scrollPosition: 0,

			videoActive: false,
			isPlaying: false,
			imageLoaded: false,
			titleImgLoaded: false,
			scrolledToBottom: false,
			displayTooltip: false,

			hideRightScrollButton: false,
			video: this.props.video
		};

		const targetAsset = props.targetAssets ? props.targetAssets[props.targetAssetIndex] : undefined;
		if (targetAsset && props.autoNavigateToTargetAsset && props.environment === EnvType.APPLETV) {
			const selectedRow = returnSelectedRowFromAsset(targetAsset, props.appleTVVideos);
			const [rowTitle, rowId] = selectedRow.split("_");
			this.rowTitle = rowTitle;
			this.rowId = rowId;
		}
		else {
			const [rowTitle, rowId] = this.props.selectedAssetRow.split("_");
			this.rowTitle = rowTitle;
			this.rowId = rowId;
		}

		this.autoScrollTo = this.autoScrollTo.bind(this);
		this.triggerPlayEvent = this.triggerPlayEvent.bind(this);
		this.trackTrailerClick = this.trackTrailerClick.bind(this);
		this.updateWatchlist = this.updateWatchlist.bind(this);
		this.slideLeft = this.slideLeft.bind(this);
		this.slideRight = this.slideRight.bind(this);
		this.toggleMute = this.toggleMute.bind(this);
		this.togglePlay = this.togglePlay.bind(this);
		this.videoEnded = this.videoEnded.bind(this);
		this.setImageFadeInInterval = this.setImageFadeInInterval.bind(this);
		this.isInViewport = this.isInViewport.bind(this);

		this.backgroundFadeInterval = {};
		this.setActiveVideoTimeout = {};
		this.setStopVideoTimeout = {};

		this.enteredShowPage = false;
	}

	componentDidMount() {
		const { svodStartTime,
			environment,
			video,
			targetAssets,
			targetAssetIndex,
			closedTargetAsset,
			handleSVODPanelResponses,
			eventHandler
		} = this.props;

		if (video) {
			this.enteredShowPage = true;
			eventHandler({
				data: {
					event_type: "page_enter",
					asset_name: video.name,
					asset_id: video._id,
					page_location: "show_page",
					time: Date.now()
				}
			});
		}

		if (video && video.focus_asset) eventHandler({ data: { event_type: 'entered_target_asset_showpage' } });

		let targetAsset = targetAssets && targetAssets[targetAssetIndex];
		let isTargetAsset = targetAsset && video && video._id === targetAsset.id;
		if (closedTargetAsset
			&& isTargetAsset
			&& environment === EnvType.APPLETV
		) {
			eventHandler({
				data: {
					event_type: 'apple_prompt_return_to_content',
					page_location: "show_page",
					targetAsset: targetAsset.name,
					asset_name: video.name,
					asset_id: video._id,
				}
			});
		}

		this.setImageFadeInInterval();
	}

	componentWillUnmount() {
		if (this.backgroundFadeInterval) clearInterval(this.backgroundFadeInterval);
		if (this.setStopVideoTimeout) clearInterval(this.setStopVideoTimeout);
		if (this.setActiveVideoTimeout) clearInterval(this.setActiveVideoTimeout);

		if (this.state.video) this.props.eventHandler({ data: { event_type: "page_exit", asset_name: this.state.video.name, asset_id: this.state.video._id, page_location: "show_page", time: Date.now() } });
	}

	componentDidUpdate(prevProps, prevState) {
		const targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
		const isCurrentVideoTargetAsset = targetAsset && this.props.video && this.props.video._id === (targetAsset.id || targetAsset._id);
		const page = document.getElementById("svod-page");
		const { svod_env } = this.props.fetchedGroup;
		const isAppleTVGuidedExperience = svod_env && svod_env.guided_experience && svod_env.guided_experience.included_appletv_page;

		if (this.props.autoNavigateToTargetAsset && isCurrentVideoTargetAsset) {
			this.props.eventHandler({ data: { event_type: "end_auto_navigation" } });
		}

		if (!prevState.imageLoaded && this.state.imageLoaded) {
			this.setActiveVideoTimeout = setTimeout(() => {
				if (!this.state.videoActive) this.setState({ videoActive: true, isPlaying: true });
			}, COUNTDOWN_TO_VIDEO_PLAY);
		}

		if (this.state.titleImgLoaded && this.state.imageLoaded) {
			clearInterval(this.backgroundFadeInterval);
		}

		if (this.props.video
			&& ((prevProps.video && this.props.video._id !== prevProps.video._id)
				|| !prevProps.video)
		) {
			if (!this.enteredShowPage) {
				this.enteredShowPage = true;

				this.props.eventHandler({
					data: {
						event_type: "page_enter",
						asset_name: this.props.video.name,
						asset_id: this.props.video._id,
						page_location: "show_page",
						time: Date.now()
					}
				});
			}

			let splashImg = document.getElementById("splash-background-img");
			let titleImg = document.getElementById("title-img");
			if (splashImg) splashImg.style.opacity = 0;
			if (titleImg) titleImg.style.opacity = 0;

			let scrollLocation = document.getElementById("hero");

			if (this.props.autoNavigateToTargetAsset && isCurrentVideoTargetAsset) {
				this.props.eventHandler({ data: { event_type: "end_auto_navigation" } });
			}

			clearInterval(this.setActiveVideoTimeout);

			setTimeout(() => {
				scrollLocation.scrollIntoView({ block: "center" });
			}, 400);

			this.props.eventHandler({
				data: {
					event_type: "update_environment_response",
					type: "show_page_change",
					asset_name: this.props.video.name,
					asset_id: this.props.video._id,
					time: Date.now()
				}
			});

			this.setImageFadeInInterval();

			this.setState({ scrollPosition: 0, videoActive: false, imageLoaded: false, titleImgLoaded: false, scrolledToBottom: false });
		}

		let vidItems = document.getElementsByClassName(`videoItem-${SHOW_PAGE_THUMBNAIL_CLASS}-${this.props.selectedAssetRow}`);
		document.documentElement.style.setProperty('--lolomo-scroll', `${this.state.scrollPosition}px`);
		for (let i = 0; i < vidItems.length; i++) {
			vidItems[i].style.transform = `translateX(${this.state.scrollPosition}px`;
		}

		if (this.props.promptWatchPage
			&& this.props.environment === EnvType.PEACOCK
			&& isCurrentVideoTargetAsset
		) {
			this.props.eventHandler({ data: { event_type: 'prompt_watch_page', type: this.props.video.content.title } });
		}

		if (this.props.promptReturnToHomePage
			&& this.props.environment === EnvType.PEACOCK
			&& !isCurrentVideoTargetAsset
		) {
			this.props.eventHandler({ data: { event_type: 'prompt_return_to_home_page', page_location: "show_page" } });
		}

		if (this.props.beginAppleGuidedExperience
			&& this.props.environment === EnvType.APPLETV
			&& !this.props.promptedTargetAsset
		) {
			if ((targetAsset && !isCurrentVideoTargetAsset) || isAppleTVGuidedExperience) {
				this.props.eventHandler({
					data: {
						event_type: 'apple_prompt_to_target_asset',
						page_location: "show_page",
						targetAsset: targetAsset ? targetAsset.name : '',
						asset_name: this.props.video.name,
						asset_id: this.props.video._id,
					}
				});
			}
		}

		if (this.props.forceGuidedExperience
			&& this.props.environment === EnvType.APPLETV
			&& !this.props.promptedForceTargetAsset
			&& (!isCurrentVideoTargetAsset || isAppleTVGuidedExperience)
		) {
			let targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
			let targetAssetName = targetAsset ? targetAsset.name : "";
			if (this.videoElement) this.videoElement.updateVideoPlayer("forcePause");
			this.props.eventHandler({
				data: {
					event_type: 'apple_force_to_target_asset',
					page_location: "show_page",
					targetAsset: targetAssetName
				}
			});
		}

		if (this.props.promptForcedTargetAsset
			&& this.props.environment === EnvType.PEACOCK
			&& !this.props.promptedForceTargetAsset
			&& !isCurrentVideoTargetAsset
		) {
			let targetAssetName = targetAsset ? targetAsset.name : "";
			this.props.eventHandler({
				data: {
					event_type: 'peacock_force_to_target_asset',
					page_location: "show_page",
					targetAsset: targetAssetName
				}
			});
		}

		if (this.props.autoNavigateToTargetAsset && !isCurrentVideoTargetAsset) {
			const { targetAssetIndex, targetAssets, videos } = this.props;
			const { targetAsset, targetAssetRow } = returnTargetAssetInfo(targetAssetIndex, targetAssets, videos);

			this.props.setSelectedAsset(targetAsset);
			this.props.setSelectedAssetRow(targetAssetRow);

			const targetAssetId = targetAsset ? targetAsset.id || targetAsset._id : "";
			const submittedSVODKey = `${SVOD_ASSET_NAVIGATION}-${targetAssetId}`;
			const submittedAnswer = returnTimeInSVOD(this.props.svodStartTime, this.props.totalModalTime);
			this.props.handleSVODPanelResponses(submittedAnswer, submittedSVODKey, targetAssetId, SVOD_ASSET_NAVIGATION);
		}

		if (this.props.autoNavigateToIncludedAppleTVPage
			|| this.props.autoNavigateToHome
		) {
			const backArrowButton = document.getElementById('navigationBackArrow');
			if (backArrowButton) backArrowButton.click();
		}

		if (!prevState.scrolledToBottom && this.state.scrolledToBottom) {
			this.props.eventHandler({
				data: {
					event_type: "scrolled_to_bottom",
					row_id: this.rowId,
					row_name: this.rowTitle,
					page_location: "show_page",
					asset_name: this.props.video.name,
					asset_id: this.props.video._id,
					time: Date.now()
				}
			});
		}

		if (!prevState.videoActive && this.state.videoActive) {
			this.setStopVideoTimeout = setTimeout(() => {
				if (this.state.videoActive) this.setState({ videoActive: false, isPlaying: false, imageLoaded: false });
			}, VIDEO_PLAY_LIMIT);
		}
		if (prevState.videoActive && !this.state.videoActive) {
			this.setImageFadeInInterval();
		}

		if (page && this.isInViewport(this.videosListEnd, 0, false) && !this.state.hideRightScrollButton) {
			this.setState({ hideRightScrollButton: true });
		} else if (page && !this.isInViewport(this.videosListEnd, 0, false) && this.state.hideRightScrollButton) {
			this.setState({ hideRightScrollButton: false });
		}
	}

	setImageFadeInInterval() {
		this.backgroundFadeInterval = setInterval(() => {
			if (!this.state.titleImgLoaded) {
				let titleImg = document.getElementById("title-img");
				if (titleImg && titleImg.complete) {
					titleImg.style.opacity = 1;
					this.setState({ titleImgLoaded: true });
				}
			}

			if (!this.state.imageLoaded && !this.state.videoActive) {
				let splashImg = document.getElementById("splash-background-img");
				if (splashImg && splashImg.complete) {
					splashImg.style.opacity = 1;
					this.setState({ imageLoaded: true });
				}
			}
		}, 500);

		let page = document.getElementById("svod-page");
		if (page) {
			page.addEventListener('scroll', (event) => {
				const element = event.target;
				if (element.scrollHeight - element.scrollTop < element.clientHeight + 200) {
					if (!this.state.scrolledToBottom) {
						this.setState({ scrolledToBottom: true });
					}
				}
			});
		}
	}

	isInViewport(asset, scrollAmount, isElement) {
		let rect;
		if (isElement) rect = asset.getBoundingClientRect();
		else if (asset.current) rect = asset.current.getBoundingClientRect();
		else return false;

		return (
			rect.top >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left - scrollAmount + 150 >= 0 &&
			rect.right - scrollAmount <= (window.innerWidth || document.documentElement.clientWidth) + 125
		);
	}

	autoScrollTo(location) {
		let scrollLocation = document.getElementById(location);
		scrollLocation.scrollIntoView({
			behavior: "smooth",
			block: "center"
		});
	}

	triggerPlayEvent() {
		const { svod_env } = this.props.fetchedGroup;
		const isTargetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;

		if (isTargetAsset
			&& this.props.environment === EnvType.PEACOCK
			&& svod_env.guided_experience
			&& svod_env.guided_experience.confirm_final_step
		) {
			this.props.eventHandler({ data: { event_type: 'prompt_final_step_confirmation' } });
		}

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "watch_episode_click",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				row_id: this.rowId,
				row_name: this.rowTitle,
				page_location: "show_page",
				time: Date.now()
			}
		});
	}

	trackTrailerClick() {
		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "trailer_click",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				row_id: this.rowId,
				row_name: this.rowTitle,
				page_location: "show_page",
				time: Date.now()
			}
		});
		this.setState({ displayTooltip: true });
	}

	updateWatchlist() {
		if (this.props.watchlist.includes(this.props.video._id.valueOf())) {
			// this.props.eventHandler({ data: { event_type: "watchlist", page_location: "show_page", action: "removed_from_watchlist", asset_id: this.props.video._id.valueOf(), time: Date.now() } });
			let newWatchlist = this.props.watchlist.filter((value) => { return value !== this.props.video._id.valueOf(); });
			this.props.updateWatchlist(newWatchlist);
		} else {
			// this.props.eventHandler({ data: { event_type: "watchlist", page_location: "show_page", action: "added_to_watchlist", asset_id: this.props.video._id.valueOf(), time: Date.now() } });
			let newWatchlist = [...this.props.watchlist, this.props.video._id.valueOf()];
			this.props.updateWatchlist(newWatchlist);
		}
	}

	toggleMute() {
		let statusLabel;
		let toggleValue;
		if (this.props.volume.volume) {
			statusLabel = "TRUE";
			toggleValue = false;
		} else {
			statusLabel = "FALSE";
			toggleValue = true;
		}

		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = statusLabel;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		this.props.toggleVolume(toggleValue);
		this.videoElement.updateVideoPlayer("volume", toggleValue);
	}

	videoEnded() {
		this.setState({ videoActive: false, imageLoaded: false });
	}

	togglePlay() {
		if (this.state.isPlaying) {
			this.videoElement.updateVideoPlayer("forcePause");
			this.setState({ isPlaying: false });
		} else {
			this.videoElement.updateVideoPlayer("forcePlay");
			this.setState({ isPlaying: true });
		}
	}

	slideLeft() {
		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "scroll_click",
				row_id: this.rowId,
				row_name: this.rowTitle,
				direction: 'left',
				page_location: "home_page",
				time: Date.now()
			}
		});

		let scrollAmount = document.body.clientWidth - 100;
		let newPos = this.state.scrollPosition + scrollAmount;
		if (newPos >= 0) {
			newPos = 0;
		}
		this.setState({ scrollPosition: newPos });
	}

	slideRight() {
		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "scroll_click",
				row_id: this.rowId,
				row_name: this.rowTitle,
				direction: 'right',
				page_location: "home_page",
				time: Date.now()
			}
		});

		let lolomoWidth = document.getElementById(`scroll-row`).scrollWidth;
		let scrollAmount = document.body.clientWidth;
		let newPos = this.state.scrollPosition - scrollAmount;

		if (this.props.environment === EnvType.PEACOCK) {
			if (!this.isInViewport(this.viewAllButton)) {
				this.setState({ scrollPosition: newPos });
			}
		} else {
			if (newPos <= (-lolomoWidth + -scrollAmount)) {
				newPos = 0;
			}
			this.setState({ scrollPosition: newPos });
		}
	}

	returnVideoRow(video, appleTVVideos) {
		if (video && appleTVVideos) {
			for (const rowlabel in appleTVVideos) {
				const videosObject = appleTVVideos[rowlabel];

				if (videosObject[video._id]) {
					return videosObject;
				}
			}
		}

		return {};
	}

	returnFilteredVideoRow(videoRow, video) {
		const filteredVideoRow = Object.keys(videoRow || {})
			.reduce((obj, key) => {
				let isValid;
				const asset = videoRow[key];
				if (video.licensed || video.original_theme) isValid = asset.transactional;
				else isValid = !asset.transactional; // if original or any other type of asset, show all non-transactional assets

				if (isValid) {
					// create new object with only the filtered assets
					obj[key] = videoRow[key];
				}
				return obj;
			}, {});

		return filteredVideoRow;
	}

	render() {
		const {
			video,
			environment,
			selectedAssetRow,
			videos, // rows and video assets that are displayed on the home page
			appleTVVideos, // rows and video assets that are "Included with AppleTV+"
			beginAppleGuidedExperience,
			targetAssets,
			closedTargetAsset,
			autoNavigateToTargetAsset,
			targetAssetIndex,
			rowInformation
		} = this.props;

		const {
			hideRightScrollButton,
			scrollPosition
		} = this.state;

		let targetAsset = targetAssets ? targetAssets[targetAssetIndex] : undefined;
		let isTargetAsset = targetAsset && video && video._id === (targetAsset.id || targetAsset._id);
		let inGuidedExperience = ((closedTargetAsset || beginAppleGuidedExperience) && isTargetAsset && environment === EnvType.APPLETV);

		if (autoNavigateToTargetAsset && !isTargetAsset) {
			return <Redirect to="/study/showpage" />;
		}

		let mpaa = <span></span>;
		if (video && video.content && video.content.mpaa && video.content.mpaa.label) {
			mpaa = <span className="index-rating">{video.content.mpaa.label}</span>;
		}

		let videosRow = this.returnFilteredVideoRow(videos[selectedAssetRow], video);
		const appleTargetedVideoRows = this.returnVideoRow(video, appleTVVideos);
		if (videosRow
			&& Object.keys(appleTargetedVideoRows).length
			&& environment === EnvType.APPLETV
			&& (video.licensed || video.original_theme)
		) {
			videosRow = appleTargetedVideoRows;
			videosRow = this.returnFilteredVideoRow(videosRow, video);
		}

		let appleTVVideosRow = appleTVVideos[selectedAssetRow];
		let videoIds = videosRow && Object.keys(videosRow).length
			? Object.keys(videosRow)
			: appleTVVideosRow && Object.keys(appleTVVideosRow).length
				? Object.keys(appleTVVideosRow)
				: [];
		videoIds = videoIds.filter(videoId => videoId !== video._id);

		if (environment === EnvType.PEACOCK) {
			let filteredVideoIds = videoIds.filter(videoId => {
				let video = videosRow[videoId];
				return !video.focus_asset;
			});
			videoIds = filteredVideoIds;
		}

		let videoItems = videoIds.map((videoId, idx) => {
			let disabledAsset = !!video.focus_asset || inGuidedExperience;
			let thumbnailVideo;
			if (videosRow && videosRow[videoId]) thumbnailVideo = videosRow[videoId];
			else if (appleTVVideosRow && appleTVVideosRow[videoId]) thumbnailVideo = appleTVVideosRow[videoId];

			if (((video.licensed || video.original_theme) && thumbnailVideo && thumbnailVideo.transactional)
				|| ((!video.licensed && !video.original_theme) && !thumbnailVideo.transactional)
			) {
				return <ThumbnailItem {...this.props}
					idx={idx}
					addedClass={SHOW_PAGE_THUMBNAIL_CLASS}
					disabledAsset={disabledAsset}
					page_location="show_page"
					source_asset_name={this.props.video.name}
					source_asset_id={this.props.video._id}
					watchlist_video={false}
					video={thumbnailVideo}
					label={selectedAssetRow}
					key={videoId}
				/>;
			}
		});

		videoItems.push(
			<span className="videos-list-end" ref={this.videosListEnd}></span>
		);

		const includedWithAppleTVVideos = videoIds.map((videoId, idx) => {
			const disabledAsset = !!video.focus_asset || inGuidedExperience;
			let thumbnailVideo;
			if (videosRow && videosRow[videoId]) thumbnailVideo = videosRow[videoId];
			else if (appleTVVideosRow && appleTVVideosRow[videoId]) thumbnailVideo = appleTVVideosRow[videoId];

			return <ThumbnailItem {...this.props}
				idx={idx}
				disabledAsset={disabledAsset}
				page_location="show_page"
				source_asset_name={this.props.video.name}
				source_asset_id={this.props.video._id}
				watchlist_video={false}
				video={thumbnailVideo}
				label={selectedAssetRow}
				key={videoId}
			/>;
		});

		let watchlistButton = '';
		if (this.props.video && this.props.watchlist.includes(this.props.video._id.valueOf())) {
			watchlistButton = (
				<button onClick={this.updateWatchlist} className="display-button mylist" id={`watchlist-${this.props.video._id.valueOf()}`}>
					<i className="fas fa-check" />
					{this.props.intl.formatMessage(svodMessages.in_next_up)}
				</button>
			);
		}
		else {
			watchlistButton = (
				<button className="display-button mylist" id={`watchlist-not-available`}>
					<i className="fas fa-plus" />
					{this.props.intl.formatMessage(svodMessages.add_to_up_next)}
				</button>
			);
		}


		switch (environment) {
			case EnvType.PEACOCK: {
				let title = (video.images.title) ? (
					<div className="title">
						<img src={video.images.title} id="title-img" alt="" />
					</div>
				) : (
					<div className="title">{video.content.title}</div>
				);

				let episodeTile = (
					<li className="episode-tile">
						<Link to="/study/watch" onClick={this.triggerPlayEvent} >
							<img className="rpo-pic" src={video.images.thumbnail} />
						</Link>
						<div className="text">
							<h2>
								{this.props.intl.formatMessage(svodMessages.episode)}
							</h2>
							<p className="logline">{video.content.logline}</p>
							{mpaa}
						</div>
					</li>
				);

				let metadata = returnSVODAssetMetadata(video);
				const brandingInfo = returnBrandingInformation(video, rowInformation);
				return (
					<div className="showpage-index" id="svod-page" >
						<div id="top"></div>

						<div className="content">
							<SVODSideMenu {...this.props} page="show_page" />

							<div className="text-content">
								<div className="show-text">
									<div className="left">
										{title}
										<div className="icon-wrapper tomato">
											<img src={rottenTomotoesImg} /> <p>97% </p>
										</div>
										<div className="icon-wrapper popcorn">
											<img src={popcornImg} /> <p>100%</p>
										</div>
										<p className="metadata">
											{metadata}
										</p>
									</div>
									<div className="right position-relative">
										<div className="asset-description">
											<p className="summary">{video.content.description}</p>
											{mpaa}
											{isTargetAsset && brandingInfo &&
												<div className="show-page-branding">
													<p className="m-0 mr-5">Presented by</p>
													<img src={brandingInfo.branding} />
												</div>
											}
										</div>
									</div>
								</div>

								<div className="showpage-buttons">
									<button className="showpage-button">
										<i className="fas fa-plus mr-10" />
										{this.props.intl.formatMessage(svodMessages.my_stuff)}
									</button>

									<Link to="/study/watch" onClick={this.triggerPlayEvent}>
										<button className="showpage-button play">
											<i className="fas fa-play fa-fw mr-10" />
											{this.props.intl.formatMessage(svodMessages.watch_now)}
										</button>
									</Link>

									<button className="showpage-button" onClick={() => this.autoScrollTo("episodes")}>
										<p>{this.props.intl.formatMessage(svodMessages.episodes)}</p>
									</button>

									<button className="showpage-button" onClick={() => this.autoScrollTo("more")}>
										<p>{this.props.intl.formatMessage(svodMessages.more_like_this)}</p>
									</button>
								</div>

								<div className="rpo-vid-div" id="hero">
									<div className="splash-img-container">
										<img className="splash-img" id="splash-background-img" src={video.images.background} alt={video.images.background} />
									</div>
								</div>

								<div id="showpage-video-cover"></div>
							</div>

							<div className="extras">
								<div className="related-thumbnails" id="more">
									<h2>
										{this.props.intl.formatMessage(svodMessages.more_like_this)}
									</h2>
									<div className="asset-grid-component">
										{videoItems}
									</div>
								</div>
							</div>

							<Footer environment={environment} />
						</div>
					</div>
				);
			}
			case EnvType.APPLETV: {
				let volumeButton;
				let videoPlayPauseButton;
				const buttonText = video && this.props.videoProgress.hasOwnProperty(video._id)
					? this.props.intl.formatMessage(svodMessages.resume_episode)
					: this.props.intl.formatMessage(svodMessages.play_first_episode);

				if (this.state.videoActive && !inGuidedExperience) {
					volumeButton = (<button className="volume-btn" id="dropdown-volume" onClick={this.toggleMute}><img src={this.props.volume.volume ? UnmutedImg : MutedImg} /></button>);
					videoPlayPauseButton = (<button className={this.state.isPlaying ? "pause-btn" : "play-btn"} onClick={this.togglePlay}><img src={this.state.isPlaying ? PauseImg : PlayImg} /></button>);
				}

				let title = (video && video.images && video.images.title) ? (
					<p className="title">
						<img src={video.images.title} id="title-img" alt="" />
						{video.licensed && <span>APPLE TV+ BONUS: AVAILABLE THROUGH JANUARY 31</span>}
					</p>
				) : (
					<p className="title">{video && video.content && video.content.title} {video && video.licensed && <span>APPLE TV+ BONUS: AVAILABLE THROUGH JANUARY 31</span>}</p>
				);

				let episodeTileImg = video && video.images && video.images.thumbnail;
				if (video && video.images && video.images.episode_thumbnail) {
					episodeTileImg = video.images.episode_thumbnail;
				}

				let episodeTile;
				if (video && video.content) {
					episodeTile = (
						<li className="episode-tile">
							<Link to="/study/watch" onClick={this.triggerPlayEvent} >
								<img className="rpo-pic" src={episodeTileImg} />
							</Link>
							<div className="text">
								<div className="title">
									{this.props.intl.formatMessage(svodMessages.episode)}
								</div>
								<p className="logline">{video.content ? video.content.logline : ""}</p>
								<div className="metadata">
									<span className="dim-text">{convertToMinutes(video.video ? video.video.duration : 0)}</span>
									<span className="dim-text">{video.content ? video.content.year : ""}</span>
									{video.video && video.video.captions && video.video.captions.length > 0 && (
										<span className="white-border-icon">
											{this.props.intl.formatMessage(svodMessages.cc)}
										</span>
									)}
									{video.content && video.content.extra_metadata && video.content.extra_metadata.sdh && (
										<span className="white-border-icon">
											{this.props.intl.formatMessage(svodMessages.sdh)}
										</span>
									)}
									{video.content && video.content.extra_metadata && video.content.extra_metadata.ad && (
										<span className="white-border-icon">
											{this.props.intl.formatMessage(svodMessages.ad)}
										</span>
									)}
								</div>
							</div>
						</li>
					);
				}

				let genresList;
				if (video && video.content && video.content.genres) {
					genresList = video.content.genres.map((genre, i) => {
						return <span className="genre" key={i}>{genre}</span>;
					});
				}

				let starringList = "";
				if (video && video.starring) {
					starringList = `${this.props.intl.formatMessage(svodMessages.starring)}: ${video.starring}`;
				}

				let scrollButtons = (
					<span id="lolomo-scroll-arrow-container">
						<button className="scrollButton scrollLeft" id={`slide-left-${this.props.label}`} onClick={this.slideLeft} ><img src={thin_left_chevron} /></button>
						<button className="scrollButton scrollRight" id={`slide-right-${this.props.label}`} onClick={this.slideRight} ><img src={thin_right_chevron} /></button>
					</span>
				);

				if (scrollPosition === 0 && !hideRightScrollButton) {
					scrollButtons = (
						<span id="lolomo-scroll-arrow-container">
							<button className="scrollButton scrollRight" id={`slide-right-${this.props.label}`} onClick={this.slideRight} ><img src={thin_right_chevron} /></button>
						</span>
					);
				} else if (scrollPosition === 0 && hideRightScrollButton) {
					scrollButtons = (
						<span id="lolomo-scroll-arrow-container"></span>
					);
				} else if (scrollPosition !== 0 && hideRightScrollButton) {
					scrollButtons = (
						<span id="lolomo-scroll-arrow-container">
							<button className="scrollButton scrollLeft" id={`slide-left-${this.props.label}`} onClick={this.slideLeft} ><img src={thin_left_chevron} /></button>
						</span>
					);
				}

				return (
					<div className="showpage-index" id="svod-page" >
						<NavigationBar {...this.props} asset={video} backRoute={this.props.backRoute} page="show_page" />
						<div id="top"></div>

						{video &&
							<div className="apple-showpage-top-section">
								<div className="above-text-content">
									<span className="left">
										{this.props.intl.formatMessage(svodMessages.appleTV)}
									</span>
									<span className="center"></span>

									<span className="right">
										{videoPlayPauseButton}
										{volumeButton}
									</span>
								</div>

								{title}

								<div className="text-content">
									<div className="left">
										<Link to="/study/watch" onClick={this.triggerPlayEvent}>
											<button className="showpage-button play"><i className="fas fa-play fa-fw" />{buttonText}</button>
										</Link>
										{watchlistButton}
									</div>

									<div className="center">
										<p className="summary">{video && video.content && video.content.description}</p>
										<div className="meta-tags">
											<span className="dim-text">{video.content && video.content.genres ? video.content.genres[0] : ""}</span>
											<span className="dim-text">{video.content.year}</span>
											<span className="dim-text">{convertToMinutes(video.video.duration)}</span>
											{mpaa}
											{video.content && video.content.extra_metadata && video.content.extra_metadata.dolby_atmos && (
												<img src={dolby_atmos}></img>
											)}
											{video.content && video.content.extra_metadata && video.content.extra_metadata.dolby_vision && (
												<img src={dolby_vision}></img>
											)}
											{video.video && video.video.captions && video.video.captions.length > 0 && (
												<span className="white-border-icon">
													{this.props.intl.formatMessage(svodMessages.cc)}
												</span>
											)}
											{video.content && video.content.extra_metadata && video.content.extra_metadata.sdh && (
												<span className="white-border-icon">
													{this.props.intl.formatMessage(svodMessages.sdh)}
												</span>
											)}
											{video.content && video.content.extra_metadata && video.content.extra_metadata.ad && (
												<span className="white-border-icon">
													{this.props.intl.formatMessage(svodMessages.ad)}
												</span>
											)}
										</div>
									</div>

									<div className="right">
										<p>{starringList}</p>
									</div>

									<div className="background-blur"></div>
								</div>

								<div className="showpage-billboard-media" id="hero">
									{this.state.videoActive && !inGuidedExperience ?
										<VideoPlayer location="SHOWPAGE" id="rpo-vid" videoEnded={this.videoEnded} onRef={ref => this.videoElement = ref} video={video} watchpage={false} {...this.props} />
										:
										<img className="splash-img" id="splash-background-img" src={video.images.background} alt={video.images.thumbnail} />
									}
								</div>
							</div>
						}

						{video &&
							<div className="apple-showpage-bottom-section">
								<div className="apple-showpage-content">

									{this.props.video.content_type !== "movie" && (
										<div className="episodes">
											<h2 className="category">
												{this.props.intl.formatMessage(svodMessages.episodes)}
											</h2>
											<ul className="episode-list">
												{episodeTile}
											</ul>
										</div>
									)}

									<div className="trailers">
										<h2 className="category">
											{this.props.intl.formatMessage(svodMessages.trailers)}
										</h2>
										<ul className="episode-list">
											<div className="trailer-tile">
												{this.state.displayTooltip && (
													<div className="disabled-asset-tooltip" id="disabled-asset-tooltip">
														{this.props.intl.formatMessage(svodMessages.not_available)}
													</div>
												)}
												<img className="rpo-pic" src={video.images.thumbnail} onClick={this.trackTrailerClick} />
											</div>
										</ul>
									</div>

									{includedWithAppleTVVideos.length &&
										<AppleTVPlusThemedRow {...this.props} asset={video} />
									}

									{videoItems.length &&
										<div className="related-thumbnails">
											<h2>
												{this.props.intl.formatMessage(svodMessages.related)}
											</h2>
											<div className="category-list" id="scroll-row">
												{videoItems}
												{scrollButtons}
											</div>
										</div>
									}

									<div className="about-section">
										<h2 className="category">
											{this.props.intl.formatMessage(svodMessages.about)}
										</h2>
										<div className="about-tile">
											<div className="title">{video.content && video.content.title}</div>
											<div className="genres dim-text">
												{genresList}
											</div>
											<p className="description">{video.content && video.content.description}</p>
										</div>
									</div>
								</div>

								<div className="info-section">
									<div className="information">
										<h2 className="dim-text">
											{this.props.intl.formatMessage(svodMessages.information)}
										</h2>
										<div>
											<label>
												{this.props.intl.formatMessage(svodMessages.released)}
											</label>
											<div>{video.content && video.content.year}</div>
										</div>
										<div>
											<label>
												{this.props.intl.formatMessage(svodMessages.rated)}
											</label>
											<div>{mpaa}</div>
										</div>
									</div>
									<div className="languages">
										<h2 className="dim-text">
											{this.props.intl.formatMessage(svodMessages.languages)}
										</h2>
										<div>
											<label>
												{this.props.intl.formatMessage(svodMessages.primary)}
											</label>
											<div>
												{this.props.intl.formatMessage(svodMessages.english)}
											</div>
										</div>
										<div>
											<label>
												{this.props.intl.formatMessage(svodMessages.additional)}
											</label>
											<div>
												{this.props.intl.formatMessage(svodMessages.other_available_languages)}
											</div>
										</div>
									</div>
									<div className="accessibility">
										<h2 className="dim-text">
											{this.props.intl.formatMessage(svodMessages.accessibility)}
										</h2>
										<div>
											<span className="white-border-icon">
												{this.props.intl.formatMessage(svodMessages.sdh)}
											</span>
											<div>
												{this.props.intl.formatMessage(svodMessages.sdh_description)}
											</div>
										</div>
										<div>
											<span className="white-border-icon">
												{this.props.intl.formatMessage(svodMessages.ad)}
											</span>
											<div>
												{this.props.intl.formatMessage(svodMessages.ad_description)}
											</div>
										</div>
									</div>

								</div>
							</div>
						}

						<Footer environment={environment} />
					</div>
				);
			}
		}
	}
}

const mapStateToProps = (state, ownProps) => ({
	selectedAssetRow: state.SVOD.selectedAssets.assetRow,
	video: state.SVOD.selectedAssets.asset,
	videos: state.SVOD.videos,
	appleTVVideos: state.SVOD.appleTVVideos,
	watchlist: state.SVOD.watchlist,
	environment: state.SVOD.environment,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	volume: state.SVOD.volume,
	videoProgress: state.SVOD.videoProgress,
	closedTargetAsset: state.SVOD.closedTargetAsset,
	rowInformation: state.targetProcess.fetchedGroup.svod_env.rows,
	targetAssets: state.targetProcess.fetchedGroup.svod_env.target_assets,
});

const mapDispatchToProps = (dispatch) => ({
	updateWatchlist: (newWatchlist) => dispatch(updateWatchlist(newWatchlist)),
	toggleVolume: (volume) => dispatch(toggleVolume(volume)),
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),
	setSelectedAssetRow: (label) => dispatch(setSelectedAssetRow(label)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ShowPage));


// WEBPACK FOOTER //
// ./src/components/svod/show-page.jsx